import styled from 'styled-components';
import { SPACES } from '@linearb/linui-common';
import { SIZES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';

export const StyledSettingStatusLogo = styled.img`
  width: 2rem;
  margin-right: 1rem;
`;

export const StyledSettingStatusTitle = styled.div`
  color: ${getColor('shark')};
  font-size: ${SIZES.large};
  font-weight: 400;
`;

export const StyledSettingStatusText = styled.div`
  font-weight: 400;
  font-size: ${SIZES.medium};
  display: flex;
  align-items: flex-end;
  svg {
    margin-right: 0.5rem;
  }
`;

export const StyledSettingStatusChildren = styled.div`
  margin-left: auto;
`;

export const StyledSettingStatusBar = styled.div`
  display: flex;
  align-items: center;
  padding: ${SPACES.small};
  min-height: 3.4rem;
  margin-bottom: 2rem;
  ${({ backgroundColor }) =>
    backgroundColor ? `background-color: ${backgroundColor}` : ''};
`;
